<lib-basys-graphics-core-data-access id="node-graphics" #dataAccess>
  <abc-toolbar #toolbar [class.toolbar--compact]="isCompact">
    <dxi-item widget="dxButton" location="before" [options]="toolbarRefreshButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarResetZoomButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarPrintButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarTableButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarMediaButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarSettingsButtonOptions"></dxi-item>

    @if (toolbarConfigurationGroupSelectBoxOptions) {
      <dxi-item location="after">
        <abc-drop-down-box
          labelMode="floating"
          [dropDownOptions]="{ wrapperAttr: { class: 'node-graphics-popup' } }"
          [label]="resourceSet.get('Layout')"
          [width]="'250px'"
          [dataSource]="toolbarConfigurationGroupSelectBoxOptions.items"
          [gridColumns]="toolbarConfigurationGroupSelectBoxOptions.gridColumns"
          [hideColumnHeaders]="true"
          [displayExpr]="toolbarConfigurationGroupSelectBoxOptions.displayExpr"
          [valueExpr]="toolbarConfigurationGroupSelectBoxOptions.valueExpr"
          [(value)]="toolbarConfigurationGroupSelectBoxOptions.value"
          [disabled]="toolbarConfigurationGroupSelectBoxOptions.disabled"
          [placeholder]="toolbarConfigurationGroupSelectBoxOptions.placeholder"
          (onValueChanged)="handleToolbarConfigurationGroupSelectBoxValueChanged($event)"
        ></abc-drop-down-box>
      </dxi-item>
    }
    @if (toolbarAdditionalIdSelectBoxOptions) {
      <dxi-item location="after">
        <abc-drop-down-box
          labelMode="floating"
          [dropDownOptions]="{ wrapperAttr: { class: 'node-graphics-popup' } }"
          [label]="toolbarAdditionalIdSelectBoxOptions.label"
          [width]="'250px'"
          [dataSource]="toolbarAdditionalIdSelectBoxOptions.items"
          [gridColumns]="toolbarAdditionalIdSelectBoxOptions.gridColumns"
          [hideColumnHeaders]="true"
          [displayExpr]="toolbarAdditionalIdSelectBoxOptions.displayExpr"
          [valueExpr]="toolbarAdditionalIdSelectBoxOptions.valueExpr"
          [(value)]="toolbarAdditionalIdSelectBoxOptions.value"
          [disabled]="toolbarAdditionalIdSelectBoxOptions.disabled"
          [placeholder]="toolbarAdditionalIdSelectBoxOptions.placeholder"
          (onValueChanged)="handleToolbarAdditionalIdSelectBoxValueChanged($event)"
        ></abc-drop-down-box>
      </dxi-item>
    }
  </abc-toolbar>
  <abc-spl
    #outerSplitter
    (onResize)="handleOuterSplitterResize($event)"
    (onItemExpanded)="handleOuterSplitterCollapsedOrExpanded($event)"
    (onItemCollapsed)="handleOuterSplitterCollapsedOrExpanded($event)"
  >
    <dxi-item [collapsed]="isCollapsedGraphicsPane" [collapsible]="isCollapsibleGraphicsPane">
      <abc-tab-panel
        #tabPanel
        class="tab-panel-popup"
        height="100%"
        (onSelectionChanging)="onSelectionChanging($event)"
      >
        <dxi-tab-panel-item [title]="resourceSet.get('Outline')">
          <lib-basys-graphics-core-scalable-image
            #scalableImageOutline
            (onFeatureClicked)="handleFeatureClicked($event)"
          ></lib-basys-graphics-core-scalable-image>
        </dxi-tab-panel-item>
        <dxi-tab-panel-item [title]="resourceSet.get('InspectionWide')">
          <lib-basys-graphics-core-scalable-image
            #scalableImageInspectionWide
            (onFeatureClicked)="handleFeatureClicked($event)"
          ></lib-basys-graphics-core-scalable-image>
        </dxi-tab-panel-item>
        <dxi-tab-panel-item [title]="resourceSet.get('InspectionLong')">
          <lib-basys-graphics-core-scalable-image
            #scalableImageInspectionLong
            (onFeatureClicked)="handleFeatureClicked($event)"
          ></lib-basys-graphics-core-scalable-image>
        </dxi-tab-panel-item>
      </abc-tab-panel>
    </dxi-item>
    <dxi-item [collapsed]="isCollapsedInfoPane" [collapsible]="isCollapsibleInfoPane">
      <abc-spl
        orientation="vertical"
        (onItemCollapsed)="handleInfoSplitterCollapsedOrExpanded($event)"
        (onItemExpanded)="handleInfoSplitterCollapsedOrExpanded($event)"
      >
        <dxi-item [collapsed]="isCollapsedTablePane" [collapsible]="isCollapsibleTablePane">
          <div class="node-info-container">
            @if (nodeData) {
              <div class="node-info-box">
                <div class="node-info-header">
                  <div class="node-info-title">{{ nodeData.bezeichnung }}</div>
                  <div class="node-info-address">
                    <i class="dx-icon dx-icon-map"></i>
                    <span>{{ nodeData.strasse }}</span>
                  </div>
                </div>
              </div>
            }
            <div [hidden]="!isPipeTable" class="grid-wrapper">
              <abc-grid
                #gridConnectedPipes
                class="custom-grid"
                height="100%"
                keyExpr="Id"
                [dataSource]="tableRowsPipe"
                (onOptionChanged)="handleTableDataSourceChanged($event)"
                (onFocusedRowChanged)="handleTableFocusedRowChanged($event)"
                [noDataText]="resourceSet.get('NoData')"
                [showBorders]="true"
                [focusedRowEnabled]="true"
                [setupDefaultLayoutOnInitialization]="true"
                [allowColumnResizing]="true"
                [loadPanel]="{ enabled: false }"
              ></abc-grid>
            </div>
            <div [hidden]="!isInspectionTable" class="grid-wrapper">
              <abc-grid
                #gridInspectionTexts
                class="custom-grid"
                height="100%"
                keyExpr="Id"
                [dataSource]="tableRowsInspection"
                (onOptionChanged)="handleTableDataSourceChanged($event)"
                (onFocusedRowChanged)="handleTableFocusedRowChanged($event)"
                [noDataText]="resourceSet.get('NoData')"
                [showBorders]="true"
                [focusedRowEnabled]="true"
                [allowColumnResizing]="true"
                [setupDefaultLayoutOnInitialization]="true"
                [loadPanel]="{ enabled: false }"
              >
              </abc-grid>
            </div>
            <div [hidden]="!isRehabilitationTable" class="grid-wrapper">
              <abc-grid
                #gridRehabilitationMeasures
                class="custom-grid"
                height="100%"
                keyExpr="Id"
                [dataSource]="tableRowsRehabilitation"
                (onOptionChanged)="handleTableDataSourceChanged($event)"
                (onFocusedRowChanged)="handleTableFocusedRowChanged($event)"
                [noDataText]="resourceSet.get('NoData')"
                [showBorders]="true"
                [focusedRowEnabled]="true"
                [allowColumnResizing]="true"
                [loadPanel]="{ enabled: false }"
              ></abc-grid>
            </div>
          </div>
        </dxi-item>
        <dxi-item [collapsed]="isCollapsedImageAndVideoPane" [collapsible]="isCollapsibleImageAndVideoPane">
          <abc-spl
            [orientation]="orientationImageAndVideoPane"
            (onItemCollapsed)="handleImageAndVideoSplitterCollapsedOrExpanded($event)"
            (onItemExpanded)="handleImageAndVideoSplitterCollapsedOrExpanded($event)"
          >
            <dxi-item [collapsed]="isCollapsedImagePane" [collapsible]="true">
              <abc-gallery
                width="100%"
                height="100%"
                [items]="photoUrls"
                [showNavButtons]="true"
                [showIndicator]="showIndicatorInGallery"
                [noDataText]="resourceSet.get('NoPhoto')"
              ></abc-gallery>
            </dxi-item>
            <dxi-item [collapsed]="isCollapsedVideoPane" [collapsible]="true"
              ><div *dxTemplate>
                <div #panoramoDiv></div>
                <video #video controls></video></div></dxi-item></abc-spl
        ></dxi-item>
      </abc-spl>
    </dxi-item>
  </abc-spl>
</lib-basys-graphics-core-data-access>

@if (loadPanelPosition && isLoadPanelVisible) {
  <div class="load-panel-container">
    <svg class="spinner" viewBox="-10 -10 120 120">
      <circle class="path" cx="50" cy="50" r="50" fill="none" stroke-width="4" stroke-miterlimit="10" />
    </svg>
  </div>
}
<abc-popup
  id="option-popup"
  [wrapperAttr]="{ class: 'option-popup-wrapper' }"
  [width]="getPopupWidth()"
  [height]="getPopupHeight()"
  [dragEnabled]="true"
  [showCloseButton]="true"
  [title]="resourceSet.get('Settings')"
  [position]="{ at: 'center', my: 'center', of: dataAccessElement().nativeElement }"
  [(visible)]="isSettingsPopupVisible"
  (onHidden)="handleSettingsPopupHidden()"
  ><dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="settingsPopupAcceptButtonOptions"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="settingsPopupCancelButtonOptions"
  ></dxi-popup-toolbar-item>
  <div class="tab-panel-popup">
    <dx-tab-panel
      class="tab-panel-popup"
      [deferRendering]="false"
      [focusStateEnabled]="false"
      [animationEnabled]="true"
      height="100%"
    >
      <dxi-item [title]="resourceSet.get('Outline')">
        <div *dxTemplate>
          <div class="optionen-popup">
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('GraphicsDocument')"
                [disabled]="isViewOutlineDisabled"
                [dataSource]="nodeGraphicsSettings.nodeGraphicsSettings.graphicsDocumentsOutline"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.graphicsDocumentIdOutline"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__field">
              <dx-number-box
                stylingMode="filled"
                labelMode="static"
                [label]="resourceSet.get('PipeDefaultLength')"
                [disabled]="isViewOutlineDisabled"
                format="0.0 m;"
                [min]="0.1"
                [max]="9.9"
                [step]="0.1"
                [showSpinButtons]="true"
                valueChangeEvent="input"
                [(value)]="nodeGraphicsSettings.pipeDefaultLength"
              ></dx-number-box>
            </div>
            <div class="optionen-popup__field">
              <dx-number-box
                stylingMode="filled"
                labelMode="static"
                [label]="resourceSet.get('DimensioningSpacing')"
                [disabled]="isViewOutlineDisabled"
                format="0.00 m;"
                [min]="0.01"
                [max]="9.99"
                [step]="0.1"
                [showSpinButtons]="true"
                valueChangeEvent="input"
                [(value)]="nodeGraphicsSettings.dimensioningSpacing"
              ></dx-number-box>
            </div>
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('DimensioningName')"
                [disabled]="isViewOutlineDisabled"
                [dataSource]="nodeGraphicsSettings.nodeGraphicsSettings.dimensioningNames"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.dimensioningName"
              ></abc-drop-down-box>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [title]="resourceSet.get('InspectionWide')">
        <div *dxTemplate>
          <div class="optionen-popup">
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('GraphicsDocument')"
                [disabled]="isViewInspectionWideDisabled"
                [dataSource]="nodeGraphicsSettings.nodeGraphicsSettings.graphicsDocumentsInspectionWide"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.graphicsDocumentIdInspectionWide"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('Configuration')"
                [disabled]="isViewInspectionWideDisabled"
                [dataSource]="nodeGraphicsSettings.nodeGraphicsSettings.configurationGroupEntriesInspectionWide"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.configurationGroupEntryInspectionWide"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__checkbox-row">
              <abc-check-box
                [disabled]="isViewInspectionWideDisabled"
                [text]="resourceSet.get('HideStatusTextsIfNotRelevant')"
                [(value)]="nodeGraphicsSettings.hideStatusTextsIfNotRelevant"
              ></abc-check-box>
            </div>
            <div class="optionen-popup__checkbox-row">
              <abc-check-box
                [disabled]="isViewInspectionWideDisabled"
                [text]="resourceSet.get('ShowAllPipes')"
                [(value)]="nodeGraphicsSettings.showAllPipes"
              ></abc-check-box>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [title]="resourceSet.get('InspectionLong')">
        <div *dxTemplate>
          <div class="optionen-popup">
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('GraphicsDocument')"
                [disabled]="isViewInspectionLongDisabled"
                [dataSource]="nodeGraphicsSettings.nodeGraphicsSettings.graphicsDocumentsInspectionLong"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.graphicsDocumentIdInspectionLong"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('Configuration')"
                [disabled]="isViewInspectionLongDisabled"
                [dataSource]="nodeGraphicsSettings.configurationGroupEntriesInspectionLong"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [value]="nodeGraphicsSettings.configurationGroupEntryInspectionLong"
                (onValueChanged)="handleSettingsPopupConfigurationEntrySelectBoxValueChanged($event)"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__checkbox-row">
              <abc-check-box
                [disabled]="isViewInspectionLongDisabled"
                [text]="resourceSet.get('HideStatusTextsIfNotRelevant')"
                [(value)]="nodeGraphicsSettings.hideStatusTextsIfNotRelevant"
              ></abc-check-box>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [title]="resourceSet.get('Reports')">
        <div *dxTemplate>
          <div class="optionen-popup">
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('Outline')"
                [disabled]="isViewOutlineDisabled"
                [dataSource]="nodeGraphicsSettings.reportDocumentsOutline"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.reportDocumentIdOutline"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__field">
              <abc-drop-down-box
                labelMode="floating"
                [label]="resourceSet.get('Inspection')"
                [disabled]="isViewInspectionWideDisabled && isViewInspectionLongDisabled"
                [dataSource]="nodeGraphicsSettings.reportDocumentsInspection"
                [gridColumns]="[{ dataField: 'displayText', caption: '' }]"
                [hideColumnHeaders]="true"
                displayExpr="displayText"
                valueExpr="id"
                [(value)]="nodeGraphicsSettings.reportDocumentIdInspection"
              ></abc-drop-down-box>
            </div>
            <div class="optionen-popup__checkbox-row">
              <abc-check-box
                [disabled]="isViewInspectionWideDisabled && isViewInspectionLongDisabled"
                [text]="resourceSet.get('ShowPhotosInReport')"
                [(value)]="nodeGraphicsSettings.showPhotosInReport"
              ></abc-check-box>
            </div>
          </div>
        </div>
      </dxi-item>
    </dx-tab-panel>
  </div>
</abc-popup>
